(() => {
  const kawaiiMap = {
    'nounours rose': 'Rose + nœud bleu',
    'minou rose': 'Rose oreilles pointues + nœud rose',
    'petit moka': 'Blanc + oreilles foncées',
    'toutou vanille': 'Jaune',
    'bunny bleu': 'Blanc + nœud bleu',
    'bunny violet': 'Violet'
  };
  const sugarProducts = {
    'Perles effet sucre – Rondes 🍬': {'bleu':'72317527195996','vert':'72317534273884','blanc':'72317532602716','jaune':'72317529850204','pêche':'72317522903388','rose clair':'72317539090780','rose bonbon':'72317536338268','lilas':'72317524476252'},
    'Perles effet sucre – Cœurs 💗': {'bleu':'72326911885660','vert':'72326911852892','blanc':'72326911820124','jaune':'72326911787356','pêche':'72326911754588','rose clair':'72326911721820','rose bonbon':'72326911689052','lilas':'72326911656284'},
    'Perles effet sucre – Étoiles ⭐': {'bleu':'72326738739548','vert':'72326738706780','blanc':'72326738674012','jaune':'72326738641244','pêche':'72326738608476','rose clair':'72326738575708','rose bonbon':'72326738542940','lilas':'72326738510172'}
  };
  function norm(v){return (v||'').toString().trim().toLocaleLowerCase('fr-FR');}
  function eventText(el){
    const parts=[]; if(!el)return '';
    if('value' in el)parts.push(el.value);
    if(el.tagName==='SELECT'&&el.selectedOptions?.[0])parts.push(el.selectedOptions[0].textContent);
    parts.push(el.getAttribute?.('aria-label'),el.getAttribute?.('data-value'),el.getAttribute?.('title'));
    const label=el.closest?.('label'); if(label)parts.push(label.textContent);
    const button=el.closest?.('button'); if(button)parts.push(button.textContent);
    return norm(parts.filter(Boolean).join(' '));
  }
  function currentTitle(){return (document.querySelector('h1')?.textContent||'').trim();}
  function showMediaId(mediaNumericId){
    const gallery=document.querySelector('media-gallery');
    if(!gallery||typeof gallery.setActiveMedia!=='function')return;
    const media=Array.from(gallery.querySelectorAll('[data-media-id]')).find(el=>{
      const id=el.dataset?.mediaId||'';
      return id===mediaNumericId||id.endsWith('-'+mediaNumericId)||id.endsWith(mediaNumericId);
    });
    if(media?.dataset?.mediaId)gallery.setActiveMedia(media.dataset.mediaId,false);
  }
  function handleSugar(el){
    const productMap=sugarProducts[currentTitle()]; if(!productMap)return false;
    const txt=eventText(el);
    const color=['rose bonbon','rose clair','pêche','lilas','bleu','jaune','blanc','vert'].find(c=>txt.includes(c));
    if(!color)return false;
    setTimeout(()=>showMediaId(productMap[color]),0); return true;
  }
  function handleKawaii(el){
    if(!currentTitle().includes('Grosses perles 3D Kawaii'))return;
    const txt=eventText(el); const choice=Object.keys(kawaiiMap).find(k=>txt.includes(k)); if(!choice)return;
    const gallery=document.querySelector('media-gallery'); if(!gallery||typeof gallery.setActiveMedia!=='function')return;
    const wantedAlt=kawaiiMap[choice];
    const img=Array.from(gallery.querySelectorAll('img')).find(i=>(i.alt||'').trim()===wantedAlt);
    const media=img?.closest?.('[data-media-id]');
    if(media?.dataset?.mediaId)setTimeout(()=>gallery.setActiveMedia(media.dataset.mediaId,false),0);
  }
  function react(e){if(handleSugar(e.target))return;handleKawaii(e.target);}
  document.addEventListener('change',react,true);
  document.addEventListener('click',react,true);
})();